<template>
  <div data-v-68894370="" data-v-2ac6a5fc="" class="userCenter userCny">
    <div data-v-68894370="" class="content" v-if="vipLis.length > 0">
      <div data-v-68894370="" class="user">
        <a 
          ><div data-v-68894370="" class="img" style="position: relative;">
            <img data-v-68894370=""  style="border-radius: 50%;" :src="$store.state.userInfo.avatar ? $store.state.userInfo.avatar :'/static/image/img1.2ceab29b.png'" />
            <input class="inputsw" type="file" @change="onchangemd" single accept="image/gif,image/png" /> 
            </div>
          <div data-v-68894370="" class="info info-login" @click="$parent.goNav('/accountCenter')">
            <h3 data-v-68894370="">{{ $store.state.userInfo.username }} <img :src="baseURL + $store.state.userInfo.vipname" style="height: 14px; margin-left: 6px" alt="" /></h3>
            <div data-v-68894370="" class="holder">
              <p data-v-68894370="">{{ $store.state.userInfo.current_vip }}</p>
              <div data-v-68894370="" class="bar"><span data-v-68894370="" class="progress" :style="`width: ${bfNum}%`"></span></div>
              <p data-v-68894370="">{{ $store.state.userInfo.next_vip }}</p>
            </div>
            <p data-v-68894370="" >累计充值 ¥{{ vipLis.filter(e=> e.id ==  $store.state.userInfo.next_vip_id)[0].recharge }}元</p>
          </div>
          
          <span data-v-68894370="" @click="$parent.goNav('/vip')" class="arrow" style="background: none;width: auto !important;">
            查看VIP详情<van-icon name="arrow" /></span
        ></a>
      </div>
      <div data-v-68894370="" class="row">
        <div data-v-68894370="" class="card card2">
          <h4 data-v-68894370="">总资产 <span data-v-68894370="" class="eye"></span><span @click="transall" style="margin-left: 48px">一键回收</span></h4>
          <div data-v-68894370="" class="value">
            <h2 data-v-68894370="">{{ $store.state.userInfo.balance }}</h2>
          </div>
          <a @click="$parent.goNav('/assets')"
            ><div data-v-68894370="" class="none">转账<span data-v-68894370="" class="arrow"></span></div
          ></a>
        </div>
        <div data-v-68894370="" class="box1">
          <div data-v-68894370="" class="item">
            <a @click="$parent.goNav('/deposit')"
              ><span data-v-68894370="" class="icon-item icon-deposit-cny"></span>
              <p data-v-68894370="">存款</p></a
            >
          </div>
          <div data-v-68894370="" class="item">
            <a @click="$parent.goNav('/assets?type=0')"
              ><span data-v-68894370="" class="icon-item icon-deposit"></span>
              <p data-v-68894370="">交易</p></a
            >
          </div>
          <div data-v-68894370="" class="item">
            <a @click="$parent.goNav('/assets?type=4')"
              ><span data-v-68894370="" class="icon-item icon-washcode-cny"></span>
              <p data-v-68894370="">投注</p></a
            >
          </div>
          <div data-v-68894370="" class="item">
            <a @click="$parent.goNav('/assets?type=5')"
              ><span data-v-68894370="" class="icon-item icon-washcode"></span>
              <p data-v-68894370="">返水</p></a
            >
          </div>
          <div data-v-68894370="" class="item">
            <a @click="$parent.goNav('/withdraw')"
              ><span data-v-68894370="" class="icon-item icon-withdrawal"></span>
              <p data-v-68894370="">取款</p></a
            >
          </div>
        </div>
      </div>
      <div data-v-68894370="" class="row">
        <div data-v-68894370="" class="box3">
          <ul data-v-68894370="">
            <li data-v-68894370="">
              <a @click="$parent.goNav('/welfare')"
                ><div data-v-68894370="" class="left-part">
                  <div data-v-68894370="" class="icon-box"><span data-v-68894370="" class="icon icon4"></span></div>
                  <p data-v-68894370="">福利中心</p>
                </div>
                <div data-v-68894370="" class="right-button">
                  <p data-v-68894370="" class="baccarat2021-promo">红包多多</p>
                  <span data-v-68894370="" class="arrow"></span></div
              ></a>
            </li>
            <li data-v-68894370="">
              <a @click="$parent.goNav('/accountCenter')"
                ><div data-v-68894370="" class="left-part">
                  <div data-v-68894370="" class="icon-box"><van-icon name="manager-o" color="#ffd163" size="25" /></div>
                  <p data-v-68894370="">账户中心</p>
                </div>
                <div data-v-68894370="" class="right-button">
                  <!-- <p data-v-68894370="">1条消息</p> -->
                  <span data-v-68894370="" class="arrow"></span></div
              ></a>
            </li>
            <li data-v-68894370="">
              <a @click="$parent.goNav('/myNews')"
                ><div data-v-68894370="" class="left-part">
                  <div data-v-68894370="" class="icon-box"><span data-v-68894370="" class="icon icon1"></span></div>
                  <p data-v-68894370="">我的消息</p>
                </div>
                <div data-v-68894370="" class="right-button">
                  <!-- <p data-v-68894370="">1条消息</p> -->
                  <span data-v-68894370="" class="arrow"></span></div
              ></a>
            </li>
            <li data-v-68894370="">
              <a @click="$parent.goNav('/faq')"
                ><div data-v-68894370="" class="left-part">
                  <div data-v-68894370="" class="icon-box"><span data-v-68894370="" class="icon icon2"></span></div>
                  <p data-v-68894370="">帮助中心</p>
                </div>
                <div data-v-68894370="" class="right-button">
                  <p data-v-68894370="">操作有疑问，看这里</p>
                  <span data-v-68894370="" class="arrow"></span></div
              ></a>
            </li>
            <li data-v-68894370="">
              <a @click="$parent.goNav('/app')"
                ><div data-v-68894370="" class="left-part">
                  <div data-v-68894370="" class="icon-box"><span data-v-68894370="" class="icon icon3"></span></div>
                  <p data-v-68894370="">下载APP</p>
                </div>
                <div data-v-68894370="" class="right-button">
                  <p data-v-68894370=""></p>
                  <span data-v-68894370="" class="arrow"></span></div
              ></a>
            </li>
          </ul>
        </div>
      </div>
      <a data-v-68894370="" class="button" @click="changMark">退出登录</a>
    </div>
    <div data-v-5742baa6="" data-v-68894370="" v-if="mark" class="dialog">
      <div data-v-5742baa6="" class="dialog-cover back" style="display: none"></div>
      <div data-v-5742baa6="" class="dialog-content" style="display: none">
        <div data-v-68894370="" class="into">
          <div data-v-68894370="" class="into__header"><span data-v-68894370="">转入福袋</span><i data-v-68894370="" class="into__close"></i></div>
          <div data-v-68894370="" class="into__content">
            <p data-v-68894370="" class="into__label">可转金额 <span data-v-68894370="" class="c-yellow">0.00元</span></p>
            <div data-v-68894370="" class="into__input-wrapper">
              <input data-v-68894370="" type="text" class="into__input" />
              <span data-v-68894370="" class="into__text-button">全部</span>
            </div>
            <p data-v-68894370="" class="into__label">福袋到账金额</p>
            <div data-v-68894370="" class="into__input-wrapper">
              <input data-v-68894370="" disabled="disabled" type="text" class="into__input" />
            </div>
            <p data-v-68894370="" class="into__label">当前汇率 <span data-v-68894370="" class="c-yellow">1USDT≈6.36CNY</span>，以实际到账时为准</p>
            <button data-v-68894370="" class="into__button">提交</button>
          </div>
        </div>
      </div>
    </div>

    <div data-v-710c460e="" data-v-29c11a50="" class="popup-background" v-if="mark">
      <div data-v-29c11a50="" data-v-710c460e="" class="safety-tip">
        <i data-v-29c11a50="" data-v-710c460e="" class="close" @click="changMark"></i>
        <div data-v-29c11a50="" data-v-710c460e="" class="title">您确定要退出吗</div>
        <div data-v-29c11a50="" data-v-710c460e="" class="unbind-box">

          <div data-v-29c11a50="" data-v-710c460e="" class="submit-btn" @click="changMark">在玩一会</div>
          <div data-v-29c11a50="" data-v-710c460e="" class="submit-btn2" @click="outLogin">退出登录</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'userCenter',
  data() {
    return { baseURL: '', bfNum: 0, vipLis: [], mark: false };
  },
  created() {
    
    let that = this;
    that.baseURL = sessionStorage.getItem('baseURL') || '';
    that.$parent.getUserInfoss();
    that.uservip();

    if(!(that.$store.state.token && that.$store.state.userInfo.username && that.$store.state.userInfo.username.length > 0)){
      that.$router.push({ path: 'login' })
      return
    }
  },
  mounted(){
    
  },
  methods: {
     onchangemd(e) {
      let that = this;

      console.log(e.target.files); 
      let formdata = new FormData();
      Array.from(e.target.files).map(item => {
        console.log(item);
        formdata.append('file', item); 
      });
            that.$parent.showLoading();

      that.$apiFun.post('/api/uploadimg', formdata).then(res => {
        that.$parent.getUserInfoss();
      });
    },
    transall() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/transall', {})
        .then(res => {
          that.$parent.showTost(1, res.message);

          that.refreshusermoney();
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    refreshusermoney() {
      let that = this;
      that.$apiFun.post('/api/refreshusermoney', {}).then(res => {
        that.$parent.hideLoading();
        if (res.code == 200) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
        }
      });
    },
    changMark() {
      this.mark = !this.mark;
    },
    outLogin() {
      let that = this;

      that.$apiFun
        .post('/api/logoff', {})
        .then(res => {
          that.$parent.showLoading();
          localStorage.clear();
          sessionStorage.clear();
          that.$store.commit('changUserInfo');
          that.$store.commit('changToken');
          setTimeout(() => {
            that.$parent.goNav('/');
            that.$parent.hideLoading();
          }, 1000);
        })
        .catch(() => {
          that.$parent.showLoading();
          localStorage.clear();
          sessionStorage.clear();
          that.$store.commit('changUserInfo');
          that.$store.commit('changToken');
          setTimeout(() => {
            that.$parent.goNav('/');
            that.$parent.hideLoading();
          }, 1000);
        });
    },
    uservip() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/uservip', {})
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.vipLis = res.data;
            that.getbfNum();
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getbfNum() {
      let that = this;
      let num = 0; 
      let vip = that.$store.state.userInfo.vip * 1; 
      that.vipLis.forEach((el, index) => {
        console.log();
        if (index == vip) {
          num = el.recharge * 1;
        }
      });
      let userMey = that.$store.state.userInfo.paysum * 1;
      let bfNum = userMey == 0 || num == 0 ? 0 : Math.round((userMey / num) * 100) ;
      that.bfNum = bfNum > 100 ? 100 : bfNum ;
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
    var num = 0;
    $('.eye').click(function () {
      $(this).toggleClass('eye-close');
      if (num++ % 2 == 0) {
        $('.value h2').text('****');
      } else {
        $('.value h2').text(that.$store.state.userInfo.balance);
      }
    });
  },
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/chunk-f0895f92.7848dd3c.css';
.header-container[data-v-e82090a2] {
  background: #3f3f3f;
}
.popup-background[data-v-710c460e] {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
}
.userCenter .box1 .item .icon-item {
  margin: 0 auto;
  margin-bottom: 5px;
}
.userCenter .card .none {
  width: 69px!important;

  color: #4a2900!important;
}
// 上传头像
.inputsw {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 999;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/main/userCenter.vue